import React, { useEffect, useRef, useState } from "react";
import teacherImage1 from "../stories/assets/course-detail-teacher-1.png";
import teacherImage2 from "../stories/assets/course-detail-teacher-2.png";
import teacherTabImage0 from "../stories/assets/course-detail-teacher-3.png";
import teacherTabImage1 from "../stories/assets/course-detail-teacher-4.png";
import reviewImage1 from "../stories/assets/course-detail-review-1.png";
import reviewImage2 from "../stories/assets/course-detail-review-2.png";
import reviewImage3 from "../stories/assets/course-detail-review-3.png";
import reviewImage4 from "../stories/assets/course-detail-review-4.png";
import reviewImage5 from "../stories/assets/course-detail-review-5.png";
import reviewImage6 from "../stories/assets/course-detail-review-6.png";
import courseDetailThumbnail from "../stories/assets/course-detail-thumbnail.png";
import { TabView, TabPanel } from "primereact/tabview";
import { Accordion, AccordionTab } from "primereact/accordion";
import { Button } from "primereact/button";
import { ProgressBar } from "primereact/progressbar";
import { Dropdown } from "primereact/dropdown";
import { Divider } from "primereact/divider";
import { getCourseItemReviewData } from "../services/courseService";

//Dummy images
const teacherTabImage = [teacherTabImage0, teacherTabImage1];
const reviewImage = [
  reviewImage1,
  reviewImage2,
  reviewImage3,
  reviewImage4,
  reviewImage5,
  reviewImage6,
];

export const CourseDetailContent = ({ reload, courseItemData }) => {
  const [courseItemReviewData, setCourseItemReviewData] = useState(null);

  const ratings = [
    { name: "5 Stars Rating", code: "5" },
    { name: "4 Stars Rating", code: "4" },
    { name: "3 Stars Rating", code: "3" },
    { name: "2 Stars Rating", code: "2" },
    { name: "1 Star Rating", code: "1" },
  ];

  const fetchcourseItemData = (data) => {
    reload(data);
  };
  const [selectedRating, setSelectedRating] = useState(ratings[0]);

  const tabsContainerRef = useRef(null);
  const [showRightIndicator, setShowRightIndicator] = useState(false);
  const [showLeftIndicator, setShowLeftIndicator] = useState(false);

  const checkScroll = () => {
    const container = tabsContainerRef.current
      .getElement()
      .querySelector(".p-tabview-nav-content");

    if (
      container.scrollWidth > container.clientWidth &&
      container.scrollLeft < container.scrollWidth - container.clientWidth
    ) {
      setShowRightIndicator(true);
    } else {
      setShowRightIndicator(false);
    }

    if (container.scrollLeft > 0) {
      setShowLeftIndicator(true);
    } else {
      setShowLeftIndicator(false);
    }
  };

  useEffect(() => {
    const container = tabsContainerRef.current
      .getElement()
      .querySelector(".p-tabview-nav-content");
    if (container) {
      checkScroll();
      container?.addEventListener("scroll", checkScroll);
      window?.addEventListener("resize", checkScroll);
    }

    return () => {
      if (container) {
        container.removeEventListener("scroll", checkScroll);
      }
      window.removeEventListener("resize", checkScroll);
    };
  }, [courseItemData]);

  const fetchCourseItemReview = async () => {
    const data = await getCourseItemReviewData(courseItemData?.id);
    setCourseItemReviewData(data);
  };

  useEffect(() => {
    if (courseItemData) fetchCourseItemReview();
  }, [courseItemData]);

  return (
    <div className="course-detail-content">
      <h1 className="font-size-30 font-weight-700 line-height-36 mt-1">
        {courseItemData?.title}
      </h1>
      <h3 className="font-size-20 font-weight-400 line-height-28 gray-color">
        {courseItemData?.subtitle}
      </h3>
      <div className="flex justify-content-between align-items-center course-detail-content-teacher-wrapper">
        <div className="flex gap-05 course-detail-teacher-img-wrapper">
          <div className="course-detail-teacher-img">
            <img alt="teacher-image" src={teacherImage1} />
            <img alt="teacher-image" src={teacherImage2} />
          </div>
          <div>
            <h4 className="font-size-14 m-0 font-weight-400 line-height-22 gray-color">
              Được giảng dạy bởi
            </h4>
            <div className="flex align-items-center course-detail-teacher-name">
              {courseItemData?.trainerTitle?.map((title, index) => (
                <div key={index} className="flex align-items-center">
                  {index !== 0 && (
                    <i className="pi pi-circle-fill mx-2 font-size-6 line-height-22 default-text"></i>
                  )}
                  <h4 className="default-text font-size-16 m-0 font-weight-500 line-height-24">
                    {title}
                  </h4>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="flex course-detail-content-teacher-rating-wrapper">
          <div className="flex align-items-center">
            {Array(5)
              .fill(null)
              .map((_, index) => (
                <>
                  {index < Math.ceil(courseItemData?.reviewPoint) ? (
                    <i className="pi pi-star-fill mr-2 font-size-18 orange-color"></i>
                  ) : (
                    <i className="pi pi-star mr-2 font-size-18 orange-color"></i>
                  )}
                </>
              ))}
          </div>
          <div className="flex align-items-center">
            <span className="default-text font-size-16 font-weight-500 line-height-22">
              {courseItemData?.reviewPoint}
            </span>
            <span>&nbsp;</span>
            <span className="font-size-14 font-weight-400 line-height-24 gray-color">
              ({courseItemData?.reviewQuantity} lượt đánh giá)
            </span>
          </div>
        </div>
      </div>
      <div className="course-detail-thumbnail">
        <img
          className="object-fit-cover"
          alt="teacher-image"
          src={courseDetailThumbnail}
        />
      </div>
      <div className="course-detail-tabview">
        <div className="relative">
          <TabView ref={tabsContainerRef}>
            <TabPanel
              header="Tổng quan"
              className="course-detail-tabview-overview"
            >
              {courseItemData?.overview?.descriptions?.map((item, index) => (
                <div key={index}>
                  <h4 className="uppercase">{item?.title}</h4>
                  {item?.contents?.map((content, contentIndex) => (
                    <p key={contentIndex}>{content}</p>
                  ))}
                </div>
              ))}
              <div className="course-detail-benefit">
                <h4 className="mb-4">
                  {courseItemData?.overview?.hightlight?.title}
                </h4>
                <div className="course-detail-benefit-grid">
                  {courseItemData?.overview?.hightlight?.contents?.map(
                    (content, index) => (
                      <div key={index} className="flex align-items-start mb-4">
                        <i className="pi pi-check-circle mr-2"></i>
                        <span className="font-size-14 font-weight-400 line-height-22 word-break-overflow gray-color">
                          {content}
                        </span>
                      </div>
                    )
                  )}
                </div>
              </div>
            </TabPanel>
            <TabPanel
              header="Nội dung"
              className="course-detail-tabview-content"
            >
              <h4>{courseItemData?.content?.requires?.title}</h4>
              {courseItemData?.content?.requires?.contents?.map(
                (item, index) => (
                  <div key={index} className="flex align-items-start mb-2">
                    <i className="pi pi-circle-fill mr-2 font-size-5 line-height-22 gray-color"></i>
                    <span className="font-size-14 font-weight-400 line-height-22 word-break-overflow gray-color">
                      {item}
                    </span>
                  </div>
                )
              )}
              <div className="mt-4 course-detail-tabview-content-title">
                <h4>{courseItemData?.content?.programs?.title}</h4>
                <div className="flex gap-3 course-detail-tabview-content-title-icon">
                  <div className="flex">
                    <i className="pi pi-folder-open mr-2 font-size-16 primary-color"></i>
                    <span className="font-size-14 font-weight-400 line-height-20 gray-color">
                      {courseItemData?.content?.programs?.titleAsset?.part} phần
                    </span>
                  </div>
                  <div className="flex">
                    <i className="pi pi-play-circle mr-2 font-size-16 red-color"></i>
                    <span className="font-size-14 font-weight-400 line-height-20 gray-color">
                      {courseItemData?.content?.programs?.titleAsset?.course}{" "}
                      bài giảng
                    </span>
                  </div>
                  <div className="flex">
                    <i className="pi pi-clock mr-2 font-size-16 orange-color"></i>
                    <span className="font-size-14 font-weight-400 line-height-20 gray-color">
                      {courseItemData?.content?.programs?.titleAsset?.duration}
                    </span>
                  </div>
                </div>
              </div>
              <Accordion
                className="mt-2 course-detail-tabview-content-accordion mb-6"
                multiple
                activeIndex={[0]}
              >
                {courseItemData?.content?.programs?.courses?.map(
                  (course, index) => (
                    <AccordionTab
                      key={index}
                      header={
                        <div className="flex align-items-center justify-content-between course-detail-tabview-content-accordion-header">
                          <h5 className="font-size-16 font-weight-500 line-height-24">
                            {course?.title}
                          </h5>
                          <div className="flex gap-3">
                            <div className="flex">
                              <i className="pi pi-play-circle mr-2 font-size-16 primary-color"></i>
                              <span className="font-size-14 font-weight-400 line-height-20 gray-color">
                                {course?.titleAsset?.course} Bài giảng
                              </span>
                            </div>
                            <div className="flex">
                              <i className="pi pi-clock mr-2 font-size-16 red-color"></i>
                              <span className="font-size-14 font-weight-400 line-height-20 gray-color">
                                {course?.titleAsset?.duration}
                              </span>
                            </div>
                          </div>
                        </div>
                      }
                    >
                      <div className="flex flex-column">
                        {course?.courseAssets?.map((asset, assetIndex) => (
                          <div
                            key={assetIndex}
                            className="flex justify-content-between align-items-center mb-3"
                          >
                            <div className="flex">
                              {asset?.type === "video" ? (
                                <i className="pi pi-play mr-2 font-size-12 primary-color"></i>
                              ) : (
                                <i className="pi pi-file mr-2 font-size-12 primary-color"></i>
                              )}
                              <span className="font-size-14 font-weight-400 line-height-22 gray-color">
                                {asset?.title}
                              </span>
                            </div>
                            <p className="font-size-14 font-weight-400 line-height-22 gray-color m-0">
                              {asset?.info}
                            </p>
                          </div>
                        ))}
                      </div>
                    </AccordionTab>
                  )
                )}
              </Accordion>
            </TabPanel>
            <TabPanel
              header="Giảng viên"
              className="course-detail-tabview-teacher"
            >
              <h4 className="font-size-24 font-weight-600 line-height-32 default-text my-3">
                {courseItemData?.teacher?.title}
                <span className="font-weight-400">
                  ({courseItemData?.teacher?.quantity})
                </span>
              </h4>
              {courseItemData?.teacher?.teacherList?.map((teacher, index) => (
                <div
                  key={index}
                  className="flex course-detail-tabview-teacher-item"
                >
                  <div>
                    <div className="course-detail-tabview-teacher-img">
                      <img alt="teacher-image" src={teacherTabImage[index]} />
                    </div>
                  </div>
                  <div className="p-5 pl-0 course-detail-tabview-teacher-item-content">
                    <h5 className="m-0 font-size-20 font-weight-600 line-height-28 default-text">
                      {teacher?.name}
                    </h5>
                    <p className="font-size-14 font-weight-400 line-height-20 gray-color mt-1 mb-3">
                      {teacher?.title}
                    </p>
                    <div className="flex gap-3 course-detail-tabview-teacher-item-content-icon">
                      <div className="flex">
                        <i className="pi pi-star-fill mr-2 font-size-16 orange-color"></i>
                        <span className="default-text font-size-16 font-weight-500 line-height-22">
                          {teacher?.rating}
                        </span>
                        <span>&nbsp;</span>
                        <span className="font-size-14 font-weight-400 line-height-24 gray-color">
                          sao
                        </span>
                      </div>
                      <div className="flex">
                        <i className="pi pi-users mr-2 font-size-16 purple-color"></i>
                        <span className="default-text font-size-16 font-weight-500 line-height-22">
                          {teacher?.studentQuantity}
                        </span>
                        <span>&nbsp;</span>
                        <span className="font-size-14 font-weight-400 line-height-24 gray-color">
                          học viên
                        </span>
                      </div>
                      <div className="flex">
                        <i className="pi pi-play-circle mr-2 font-size-16 primary-color"></i>
                        <span className="default-text font-size-16 font-weight-500 line-height-22">
                          {teacher?.courseQuantity}
                        </span>
                        <span>&nbsp;</span>
                        <span className="font-size-14 font-weight-400 line-height-24 gray-color">
                          Khóa học
                        </span>
                      </div>
                    </div>
                    <p className="font-size-14 font-weight-400 line-height-20 gray-color">
                      {teacher?.description}
                    </p>
                    <Button
                      label="Xem thêm"
                      link
                      className="font-weight-500 font-size-14 line-height-20 none-focus-outline-btn p-0 default-text"
                    />
                  </div>
                </div>
              ))}
            </TabPanel>
            <TabPanel
              header="Đánh giá"
              className="course-detail-tabview-review"
            >
              <h4 className="default-text font-size-24 font-weight-600 line-height-32 my-3">
                {courseItemReviewData?.title}
              </h4>
              <div className="flex course-detail-tabview-review-rating">
                <div className="course-detail-tabview-review-rating-total">
                  <h1 className="default-text font-size-48 font-weight-600 line-height-57 my-4">
                    {courseItemReviewData?.totalReview?.rating}
                  </h1>
                  <div className="flex">
                    {Array(5)
                      .fill(null)
                      .map((_, index) => (
                        <>
                          {index <
                          Math.ceil(
                            courseItemReviewData?.totalReview?.rating
                          ) ? (
                            <i className="pi pi-star-fill mr-1 font-size-15 orange-color"></i>
                          ) : (
                            <i className="pi pi-star mr-1 font-size-15 orange-color"></i>
                          )}
                        </>
                      ))}
                  </div>
                  <p className="default-text font-size-14 font-weight-500 line-height-20 mb-5">
                    Đánh giá
                  </p>
                </div>
                <div className="course-detail-tabview-review-rating-detail ml-4">
                  <div className="flex align-items-center my-3 course-detail-tabview-review-rating-detail-item">
                    <div className="flex">
                      <i className="pi pi-star-fill mr-1 font-size-15 orange-color"></i>
                      <i className="pi pi-star-fill mr-1 font-size-15 orange-color"></i>
                      <i className="pi pi-star-fill mr-1 font-size-15 orange-color"></i>
                      <i className="pi pi-star-fill mr-1 font-size-15 orange-color"></i>
                      <i className="pi pi-star-fill mr-1 font-size-15 orange-color"></i>
                    </div>
                    <span className="font-size-14 font-weight-400 line-height-20 gray-color ml-2">
                      Xếp hạng 5 sao
                    </span>
                    <div className="course-detail-tabview-review-rating-progress">
                      <ProgressBar
                        value={courseItemReviewData?.totalReview?.starValue[0]}
                        displayValueTemplate={() => <></>}
                      ></ProgressBar>
                    </div>
                    <div className="default-text font-size-14 font-weight-500 line-height-20 w-2rem text-right">
                      {courseItemReviewData?.totalReview?.starInfo[0]}
                    </div>
                  </div>
                  <div className="flex align-items-center my-3 course-detail-tabview-review-rating-detail-item">
                    <div className="flex">
                      <i className="pi pi-star-fill mr-1 font-size-15 orange-color"></i>
                      <i className="pi pi-star-fill mr-1 font-size-15 orange-color"></i>
                      <i className="pi pi-star-fill mr-1 font-size-15 orange-color"></i>
                      <i className="pi pi-star-fill mr-1 font-size-15 orange-color"></i>
                      <i className="pi pi-star mr-1 font-size-15 orange-color"></i>
                    </div>
                    <span className="font-size-14 font-weight-400 line-height-20 gray-color ml-2">
                      Xếp hạng 4 sao
                    </span>
                    <div className="course-detail-tabview-review-rating-progress">
                      <ProgressBar
                        value={courseItemReviewData?.totalReview?.starValue[1]}
                        displayValueTemplate={() => <></>}
                      ></ProgressBar>
                    </div>
                    <div className="default-text font-size-14 font-weight-500 line-height-20 w-2rem text-right">
                      {courseItemReviewData?.totalReview?.starInfo[1]}
                    </div>
                  </div>
                  <div className="flex align-items-center my-3 course-detail-tabview-review-rating-detail-item">
                    <div className="flex">
                      <i className="pi pi-star-fill mr-1 font-size-15 orange-color"></i>
                      <i className="pi pi-star-fill mr-1 font-size-15 orange-color"></i>
                      <i className="pi pi-star-fill mr-1 font-size-15 orange-color"></i>
                      <i className="pi pi-star mr-1 font-size-15 orange-color"></i>
                      <i className="pi pi-star mr-1 font-size-15 orange-color"></i>
                    </div>
                    <span className="font-size-14 font-weight-400 line-height-20 gray-color ml-2">
                      Xếp hạng 3 sao
                    </span>
                    <div className="course-detail-tabview-review-rating-progress">
                      <ProgressBar
                        value={courseItemReviewData?.totalReview?.starValue[2]}
                        displayValueTemplate={() => <></>}
                      ></ProgressBar>
                    </div>
                    <div className="default-text font-size-14 font-weight-500 line-height-20 w-2rem text-right">
                      {courseItemReviewData?.totalReview?.starInfo[2]}
                    </div>
                  </div>
                  <div className="flex align-items-center my-3 course-detail-tabview-review-rating-detail-item">
                    <div className="flex">
                      <i className="pi pi-star-fill mr-1 font-size-15 orange-color"></i>
                      <i className="pi pi-star-fill mr-1 font-size-15 orange-color"></i>
                      <i className="pi pi-star mr-1 font-size-15 orange-color"></i>
                      <i className="pi pi-star mr-1 font-size-15 orange-color"></i>
                      <i className="pi pi-star mr-1 font-size-15 orange-color"></i>
                    </div>
                    <span className="font-size-14 font-weight-400 line-height-20 gray-color ml-2">
                      Xếp hạng 2 sao
                    </span>
                    <div className="course-detail-tabview-review-rating-progress">
                      <ProgressBar
                        value={courseItemReviewData?.totalReview?.starValue[3]}
                        displayValueTemplate={() => <></>}
                      ></ProgressBar>
                    </div>
                    <div className="default-text font-size-14 font-weight-500 line-height-20 w-2rem text-right">
                      {courseItemReviewData?.totalReview?.starInfo[3]}
                    </div>
                  </div>
                  <div className="flex align-items-center my-3 course-detail-tabview-review-rating-detail-item">
                    <div className="flex">
                      <i className="pi pi-star-fill mr-1 font-size-15 orange-color"></i>
                      <i className="pi pi-star mr-1 font-size-15 orange-color"></i>
                      <i className="pi pi-star mr-1 font-size-15 orange-color"></i>
                      <i className="pi pi-star mr-1 font-size-15 orange-color"></i>
                      <i className="pi pi-star mr-1 font-size-15 orange-color"></i>
                    </div>
                    <span className="font-size-14 font-weight-400 line-height-20 gray-color ml-2">
                      Xếp hạng 1 sao
                    </span>
                    <div className="course-detail-tabview-review-rating-progress">
                      <ProgressBar
                        value={courseItemReviewData?.totalReview?.starValue[4]}
                        displayValueTemplate={() => <></>}
                      ></ProgressBar>
                    </div>
                    <div className="default-text font-size-14 font-weight-500 line-height-20 w-2rem text-right">
                      {courseItemReviewData?.totalReview?.starInfo[4]}
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex justify-content-between mt-5 course-detail-tabview-review-item-wrapper-title">
                <h4 className="default-text font-size-24 font-weight-600 line-height-32 m-0">
                  Đánh giá từ học viên
                </h4>
                <Dropdown
                  value={selectedRating}
                  onChange={(e) => setSelectedRating(e.value)}
                  options={ratings}
                  optionLabel="name"
                />
              </div>
              {courseItemReviewData?.studentReview?.map((item, index) => (
                <div key={index}>
                  {index !== 0 && <Divider className="gray-border" />}
                  <div className="flex course-detail-tabview-review-item mt-4">
                    <div>
                      <div className="course-detail-tabview-review-item-img mr-3">
                        <img alt="review-image" src={reviewImage[index]} />
                      </div>
                    </div>
                    <div>
                      <div className="flex align-items-center mb-2">
                        <span className="default-text font-size-14 font-weight-500 line-height-20">
                          {item?.name}
                        </span>
                        <i className="pi pi-circle-fill mx-2 font-size-5 line-height-22 gray-color -mb-1"></i>
                        <span className="font-size-12 font-weight-400 line-height-16 gray-color">
                          {item?.time}
                        </span>
                      </div>
                      <div className="flex align-items-center my-2">
                        {Array(5)
                          .fill(null)
                          .map((_, index) => (
                            <>
                              {index < Math.ceil(item?.rating) ? (
                                <i className="pi pi-star-fill mr-1 font-size-12 orange-color"></i>
                              ) : (
                                <i className="pi pi-star mr-1 font-size-12 orange-color"></i>
                              )}
                            </>
                          ))}
                      </div>
                      <p className="gray-color font-size-14 font-weight-400 line-height-20 mb-0">
                        {item?.review}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
              <Button
                className="lg-btn-primary center-icon-btn justify-content-center my-5"
                label="Xem thêm"
                iconPos="right"
                icon="pi pi-history"
                onClick={fetchCourseItemReview}
              />
            </TabPanel>
          </TabView>
          {showLeftIndicator && (
            <div className="scroll-indicator left">
              <i className="pi pi-angle-left font-size-12 line-height-22 primary-color"></i>
            </div>
          )}
          {showRightIndicator && (
            <div className="scroll-indicator right">
              <i className="pi pi-angle-right font-size-12 line-height-22 primary-color"></i>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
